import { Component, OnInit } from "@angular/core";
import { AngularFireAuth } from "angularfire2/auth";
import * as firebase from "firebase/app";
import { debounceTime } from "rxjs/operator/debounceTime";
import { Subject } from "rxjs/Subject";
import { Subscription } from "rxjs/Subscription";
import { AccountService } from "./../shared/account/account.service";
import { AuthService } from "./../shared/services/auth.service";
import { DEFAULT_INTERRUPTSOURCES, Idle } from "@ng-idle/core";
import { Keepalive } from "@ng-idle/keepalive";
import { AngularFireDatabase } from "angularfire2/database";
@Component({
  selector: "app-dashboard",
  templateUrl: "./dashboard.component.html",
  styleUrls: ["./dashboard.component.css"]
})
export class DashboardComponent implements OnInit {
  private authInstance: AngularFireAuth;
  authState: firebase.User | null;
  activeRouteIndex: number;
  routeSubscription: Subscription;
  timeoutMessage: string;
  communityId: string;

  idleState = "Not started.";
  timeoutWarning = false;
  timedOut = false;
  lastPing?: Date = null;

  private _alert = new Subject<string>();
  subscription: Subscription;

  constructor(
    private authService: AuthService,
    private accountService: AccountService,
    private idle: Idle,
    private keepalive: Keepalive,
    private db: AngularFireDatabase
  ) {
    this.authInstance = this.authService.getAngularFireAuthInstance();
    this.authState = this.authService.getAuthState();

    this.idle.onTimeoutWarning.subscribe(countdown => {
      this.idleState = "You will time out in " + countdown + " seconds!";
      if (countdown % 30 === 0) {
        this.showAlertonPage(false, this.idleState);
      }
    });
  }

  ngOnInit(): void {
    this.accountService.getActiveRoleDetails().then((role: any) => {

      if (role !== undefined) {
      this.activeRouteIndex = role.index;
      this.communityId = role.communityId;
      }
    });
  }

  showAlertonPage(msgType, msg): void {
    this.subscription = this._alert.subscribe(
      message =>
        msgType
          ? (this.timeoutMessage = message)
          : (this.timeoutMessage = message)
    );
    debounceTime
      .call(this._alert, 4000)
      .subscribe(
        () =>
          msgType
            ? (this.timeoutMessage = undefined)
            : (this.timeoutMessage = undefined)
      );
    this._alert.next(msg);
    this.subscription.unsubscribe();
  }
}



// WEBPACK FOOTER //
// ./src/app/dashboard/dashboard.component.ts